export var defaultChatDensity = 'comfy';